export const BRAND_COLLECTION = 'brands';
export const DEVICE_COLLECTION = 'devices';
export const DISPLAY_EVENTS_COLLECTION = 'displayEvents';
export const DISPLAY_MESSAGES_COLLECTION = 'displayMessages';
export const DEVICE_HEALTH_COLLECTION = 'deviceHealth';
